/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InternalUserCompanyResponseV3Logo interface.
 */
export function instanceOfInternalUserCompanyResponseV3Logo(value) {
    return true;
}
export function InternalUserCompanyResponseV3LogoFromJSON(json) {
    return InternalUserCompanyResponseV3LogoFromJSONTyped(json, false);
}
export function InternalUserCompanyResponseV3LogoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mediumUrl': json['medium_url'] == null ? undefined : json['medium_url'],
        'previewUrl': json['preview_url'] == null ? undefined : json['preview_url'],
        'wideUrl': json['wide_url'] == null ? undefined : json['wide_url'],
    };
}
export function InternalUserCompanyResponseV3LogoToJSON(json) {
    return InternalUserCompanyResponseV3LogoToJSONTyped(json, false);
}
export function InternalUserCompanyResponseV3LogoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'medium_url': value['mediumUrl'],
        'preview_url': value['previewUrl'],
        'wide_url': value['wideUrl'],
    };
}
